import { createSimpleCustomFieldsApi } from '../custom-fields';
import { ItemType } from '../domain';
export var createUsersApi = function (baseUrl, http) {
    var api = {
        adminSearch: function (dto) {
            return http.post(baseUrl + "/users/search/admin", dto);
        },
        dashboardSearch: function (dto) {
            return http.post(baseUrl + "/users/dashboard/search", dto);
        },
        agentSearch: function (dto) {
            return http.post(baseUrl + "/agents/search", dto);
        },
        updateUser: function (dto) {
            return http.put(baseUrl + "/users/" + dto.userId, dto.data);
        },
        addUser: function (dto) { return http.post(baseUrl + "/users", dto); },
        addBulkUsers: function (dto) { return http.post(baseUrl + "/users/bulk", dto); },
        get: function (dto) { return http.get(baseUrl + "/users/" + dto.id); },
        getAgents: function (dto) { return http.get(baseUrl + "/agents?userType=" + dto.userType); },
        getBanState: function (userId) { return http.get(baseUrl + "/users/" + userId + "/ban"); },
        banUser: function (dto) { return http.post(baseUrl + "/users/" + dto.id + "/ban", dto); },
        unbanUser: function (dto) { return http.delete(baseUrl + "/users/" + dto.id + "/ban"); },
        updateUsersCompany: function (dto) { return http.put(baseUrl + "/users/company", dto); },
        setUserCompanies: function (dto) { return http.put(baseUrl + "/users/" + dto.userId + "/companies", dto.data); },
        addUserNote: function (dto) { return http.post(baseUrl + "/users/" + dto.id + "/notes", dto); },
        getUserNotes: function (userId) { return http.get(baseUrl + "/users/" + userId + "/notes"); },
        customFields: createSimpleCustomFieldsApi(baseUrl + "/users", http, ItemType.USER),
        updateUserCustomFields: function (dto) { return http.put(baseUrl + "/users/" + dto.id + "/fields", dto); },
        setUsersCompanies: function (dto) { return http.put(baseUrl + "/users/companies", dto); },
    };
    return api;
};
//# sourceMappingURL=index.js.map